export default {
  title: 'Portail client',
  titlePrefix: 'au ',
  ErrorTitle: 'Erreur technique',
  ErrorMessage: 'Nous sommes désolés des inconvénients que cela peut vous causer.',
  ErrorRetryButton: 'Réessayer',
  NotFoundTitle: 'Page introuvable',
  NotFoundMessage: 'Désolé, la page a été déplacée ou supprimée.',
  NotFoundBackButton: 'Retour',
  copyright: `Investia Services financiers inc. est une filiale à part entière de l’Industrielle Alliance, Assurance et services financiers inc., une société d’assurance <1></1> de personnes qui exerce ses activités sous le nom commercial de iA Groupe financier. © ${new Date().getFullYear()} Investia Services financiers - Tous droits réservés`,
};
